
import { Client } from './clientTypes';

export const manufacturingClients: Client[] = [
  { 
    id: 20, 
    name: "PFANAST", 
    logoPath: "/lovable-uploads/8a079da8-bd81-4737-bbba-600c65a391c1.png",
    altText: "Logo de PFANAST"
  },
  { 
    id: 21, 
    name: "Ideales", 
    logoPath: "/lovable-uploads/88ffec40-dab2-4c05-8a41-8eb3dfff1142.png",
    altText: "Logo de Ideales"
  },
  { 
    id: 22, 
    name: "Idoneum", 
    logoPath: "/lovable-uploads/d8c6e5e7-c18c-4a6d-bc6c-13a27c09a278.png",
    altText: "Logo de Idoneum"
  },
  { 
    id: 23, 
    name: "IDS", 
    logoPath: "/lovable-uploads/51e24a6d-21df-4265-9856-d9b161990ca7.png",
    altText: "Logo de IDS"
  },
  { 
    id: 24, 
    name: "ITS InfoCom", 
    logoPath: "/lovable-uploads/ab3915f2-5a30-4593-9ded-0d6fe2cafc32.png",
    altText: "Logo de ITS InfoCom"
  },
  { 
    id: 31, 
    name: "Proquinal", 
    logoPath: "/lovable-uploads/53226549-e368-4e8a-983c-d66bc320a7a3.png",
    altText: "Logo de Proquinal" 
  },
  { 
    id: 32, 
    name: "Platino", 
    logoPath: "/lovable-uploads/a9c36b30-146e-425b-b4cf-3515a48f2417.png",
    altText: "Logo de Platino" 
  },
  { 
    id: 36, 
    name: "UA Brands", 
    logoPath: "/lovable-uploads/4a0277e8-06ba-459f-aab1-7490f6044bb4.png",
    altText: "Logo de UA Brands" 
  },
];
